import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'at-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input() size: string;
  @Input() color: string;
  @Input() title: string;
  @Input() content: string;

  constructor(private element: ElementRef) { }

  ngOnInit() {
  }

  closeClick() {
    this.element.nativeElement.getElementsByClassName('at-alert')[0].classList.add('hidden');
  }

}
